import React, { Fragment } from "react";
import CreditAccordion from "../CreditAccordion";

function PurchaseCreditReportFAQ() {
    const creditLockInfo = (index: number) => {
        switch (index) {
            case 1:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>
                                    Federal legislation makes every U.S. consumer eligible for one free copy of their credit report from each of the three national
                                    credit reporting agencies every 12 months. Get your free report now at annualcreditreport.com.
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="credit-lock-collapse-ul">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>
                                    Checking your own credit report won't hurt your score because it's considered a soft inquiry. A soft inquiry is a more routine
                                    check that does not affect your credit score and is generally only seen by you. On the other hand, a hard inquiry occurs when a
                                    potential lender obtains your credit information in connection with a credit application.
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="credit-lock-collapse-ul">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>
                                    A credit report shows a listing of your credit history. A credit score represents what's in the credit report, shown by a number
                                    typically between 300 and 850. There are many different types of credit scores, and it's normal to have more than one. Lenders
                                    and credit reporting agencies use varying scoring models to calculate credit scores, and the score you view may not be the score
                                    used by a particular lender. TransUnion uses the VantageScore® 3.0 credit score.
                                </p>
                            </div>
                        </div>
                    </div>
                );

            case 4:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>
                                    You have three different credit reports because there are three national credit bureaus (also known as credit reporting
                                    agencies) and each one collects information on you separately. For example, lenders can choose to report to one, two or all
                                    three bureaus. Because of this, the information in your reports can vary, which is partly why your scores can differ too. Your
                                    scores can also differ because there are many different credit scores in the market. Each of them looks at and calculates your
                                    credit report information differently.
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case 5:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>
                                    Typically, the negative information on your credit report falls off 7 years after the date of first account delinquency.
                                    Bankruptcy information remains on your report for up to 10 years from the date filed, but it can be less depending on the type
                                    of bankruptcy.
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case 6:
                return (
                    <div className="credit-lock-collapse-text">
                        <div className="row">
                            <div style={{ paddingTop: "0.5rem", paddingLeft: "0.5rem" }}>
                                <p>
                                    If you believe something on your credit report is inaccurate, you may want to contact the lender or company that reported the
                                    information to give you more details. You can also start a dispute with the credit reporting agency (bureau) that issued the
                                    report. The fastest and easiest way to start a dispute with TransUnion is to{" "}
                                    <a href="https://www.transunion.com/credit-disputes/dispute-your-credit" target="_blank" rel="noreferrer">
                                        dispute online
                                    </a>
                                    .
                                </p>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    const creditLockHeader = [
        {
            id: 1,
            name: "How can I get my free annual credit report?",
            content: creditLockInfo(1),
        },
        {
            id: 2,
            name: "Will checking my credit report hurt my credit score?",
            content: creditLockInfo(2),
        },
        {
            id: 3,
            name: "What's the difference between a credit report and a credit score?",
            content: creditLockInfo(3),
        },
        {
            id: 4,
            name: "Why do I have three different credit reports and scores?",
            content: creditLockInfo(4),
        },
        {
            id: 5,
            name: "How long does negative information stay on my credit report?",
            content: creditLockInfo(5),
        },
        {
            id: 6,
            name: "How do I dispute information on my credit report?",
            content: creditLockInfo(6),
        },
    ];

    return (
        <div className="row" id="content">
            <div className="col-xs col-gutter-vertical margin-top-s">
                <div className="box">
                    <div className="box-content">
                        <CreditAccordion
                            headers={creditLockHeader.map((v: any, i: number) => (
                                <Fragment key={`${v.id}-${i}`}>{v.name}</Fragment>
                            ))}
                            content={creditLockHeader.map((v: any, i: number) => (
                                <Fragment key={v.id}>{v.content}</Fragment>
                            ))}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PurchaseCreditReportFAQ;
